import React from "react";

export const IconButton = ({ onClick, title, iconName }) => (
	<button
		className="button is-primary is-full-width is-small"
		onClick={onClick}
		title={title}
	>
		<span className="icon">
			<i className={`fas ${iconName} is-primary`} />
		</span>
	</button>
);
